import { h } from 'preact';

import Store from 'store/store';
import List from 'components/list/list';

// import s from 'components/list/list.sss';

export default class HubPagesList extends List {
	get itemsSource() {
		return this.props.data?.pages || {};
	}

	// get attributes() {
	// 	const base = super.attributes;
	// 	return Object.fromEntries(
	// 		Object.entries(base).map(([id, data]) => [id, { ...data, required: true }])
	// 	);
	// }

	getTitle() {
		return 'Pages';
	}

	getDescription() {
		return 'Pages that aren’t tied to a specific movie';
	}

	renderViewModeOptions() {
		return [];
	}

	getItemLink(item) {
		return `#pages/${item.slug}/edit`;
	}

	getItemImage(item) {
		const isFocus = Store.get().domains?.isFocus;
		const subPath = isFocus ? 'focus/' : '';
		return item.src || `${__IMAGE_ROOT__}/pages/${subPath}${item.slug}.webp`;
	}

	renderGridItemName(item) {
		return [
			<a href={this.getItemLink(item)}>{this.getItemName(item)}</a>,
			this.renderStatus(item),
		];
	}

	// renderStatus(item) {
	// 	const live = !!item.commits.publish;
	// 	const hasChanges = live && item.commits.current?.id !== item.commits.publish?.id;
	// 	return this.renderBadge(live ? 'live' : 'draft', hasChanges);
	// }
}